import React, { useRef } from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { QrCodeItemStyled } from './styled';
import QRCode from 'react-qr-code';

// มาตรฐาน QR บังคับให้มีขอบว่างรอบโค้ดอย่างน้อย 4 module (quiet zone)
// react-qr-code วาด svg เท่าตาราง module พอดี ไม่มีขอบให้
// ตอนโชว์บนเว็บได้ขอบขาวจากพื้นการ์ดของหน้าเพจ เลยสแกนติด
// แต่ png ที่โหลดออกไปไม่มีขอบติดไปด้วย พอเปิดบนพื้นหลังสีเข้ม
// module ดำจะชนขอบภาพ หา finder pattern ไม่เจอ สแกนไม่ติด
const QUIET_ZONE_MODULES = 4;
// วาดให้ 1 module = จำนวน px เต็มจำนวน กัน module เบลอตอนซูมหรือปริ้น
const PX_PER_MODULE = 8;

const QrCodeItem = ({ theme_standard, code, label }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const containerRef = useRef(null);

  const _onImageCownload = () => {
    // ต้องอ่าน svg ผ่าน ref เท่านั้น
    // เดิมใช้ document.getElementById('QRCode') แต่ทุกใบตั้ง id ซ้ำกันหมด
    // getElementById จึงคืนใบแรกเสมอ → กดโหลดใบไหนก็ได้รูปของใบแรก
    // ทำให้ qrcode ที่เอาไปติดหน้างานเป็นรหัสเดียวกันทุกจุด สแกนใบที่ 2 ไม่ผ่าน
    const svg = containerRef.current?.querySelector('svg');
    if (!svg) return;

    // viewBox ของ react-qr-code คือ "0 0 <จำนวน module> <จำนวน module>"
    // ใช้ค่านี้คำนวณขนาดจริง จะได้ไม่ผูกกับ size ที่โชว์บนหน้าจอ
    const modules = Number((svg.getAttribute('viewBox') || '').split(' ')[2]);
    const codeSize = (modules || 0) * PX_PER_MODULE || svg.clientWidth || 156;
    const padding = QUIET_ZONE_MODULES * PX_PER_MODULE;
    const canvasSize = codeSize + padding * 2;

    // clone แล้วขยาย width/height ก่อน serialize
    // ถ้าปล่อยไว้ที่ 156px ตัว svg จะถูก raster ที่ความละเอียดเดิมแล้วค่อยยืด ภาพจะเบลอ
    const scaledSvg = svg.cloneNode(true);
    scaledSvg.setAttribute('width', codeSize);
    scaledSvg.setAttribute('height', codeSize);
    const svgData = new XMLSerializer().serializeToString(scaledSvg);

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      canvas.width = canvasSize;
      canvas.height = canvasSize;
      // canvas เริ่มต้นโปร่งใส ถ้าไม่ถมขาว ขอบ quiet zone จะกลายเป็นสีพื้นหลัง
      // ของโปรแกรมที่เปิดไฟล์ (เช่น Preview โหมดมืด) แล้วสแกนไม่ติดเหมือนเดิม
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvasSize, canvasSize);
      ctx.drawImage(img, padding, padding, codeSize, codeSize);
      const pngFile = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      // ตั้งชื่อไฟล์ตามรหัส จะได้ไม่ทับกันตอนโหลดหลายใบ และรู้ว่าใบไหนเป็นใบไหน
      downloadLink.download = `QRCode-${String(label || code)
        .replace(/[^a-zA-Z0-9-_]/g, '-')
        .slice(0, 60)}.png`;
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  return (
    <QrCodeItemStyled>
      <div className={customClass}>
        <div className="qrcode_item_container" ref={containerRef}>
          <QRCode title="Yamaha activity qrcode" value={code} size={156} />
          <div className="qrcode_label">{label || code}</div>
          <button
            className="btn_qrcode_download"
            type="button"
            onClick={_onImageCownload}
          >
            Download
          </button>
        </div>
      </div>
    </QrCodeItemStyled>
  );
};

QrCodeItem.propTypes = {};

export default QrCodeItem;
